import React, { useCallback } from 'react';
import { Text, Icon, Tooltip, useTheme } from '@Sage/hoi-poi-ui';

const CopilotSidebarAgent = ({ agent, classes, onClick, onRemove }) => {
    const theme = useTheme();
    const onRemoveAgent = useCallback(
        (e) => {
            e.stopPropagation();
            onRemove(agent);
            return false;
        },
        [agent, onRemove],
    );

    const onClickAgent = useCallback(() => {
        onClick(agent);
    }, [agent, onClick]);

    return (
        <div className={classes.agent} onClick={onClickAgent}>
            <div className={classes.agentHeader}>
                <div className={classes.agentName}>
                    {agent.url && (
                        <Tooltip className={classes.tooltip} content={agent.url}>
                            <span>
                                <Icon name="contentLink" color={theme.colors.grey[500]} />
                            </span>
                        </Tooltip>
                    )}
                    <Text type="h6" isTruncated useTooltip>
                        {agent.name}
                    </Text>
                </div>

                <Icon name="delete" onClick={onRemoveAgent} className={classes.deleteIcon} />
            </div>
            <Text type="body">{agent.instructions}</Text>
        </div>
    );
};

export default CopilotSidebarAgent;
